<div fxFlex="0 1" class="spinner-buttons" fxLayout="column" fxLayoutAlign="start end">
  <bfx-icon-button
    #upButton
    size="xs"
    class="spinner-button spinner-button-up"
    tabindex="-1"
    (componentFocus)="onFocus($event)"
    [disabled]="disabled || upDisabled || locked"
    (componentBlur)="onBlur($event)"
    (mousedown)="onMouseDown($event, true)"
    (mouseup)="onMouseUp($event)"
    (mouseleave)="onMouseLeave($event)"
    [ngClass]="{'disabled': disabled ||upDisabled || locked,'btn-inactive': !locked}"
    iconClass="icon-ion_chevron_up"
  >
  </bfx-icon-button>
  <bfx-icon-button
    #downButton
    size="xs"
    class="spinner-button spinner-button-down"
    tabindex="-1"
    [disabled]="disabled || downDisabled || locked"
    (componentFocus)="onFocus($event)"
    (componentBlur)="onBlur($event)"
    (mousedown)="onMouseDown($event, false)"
    (mouseup)="onMouseUp($event)"
    (mouseleave)="onMouseLeave($event)"
    [ngClass]="{
      'disabled': disabled || downDisabled || locked,
     'btn-inactive': !locked}"
    iconClass="icon-ion_chevron_down"
  >
  </bfx-icon-button>
</div>
